import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Dialog from '@material-ui/core/Dialog';

const styles = {

};

class SimpleDialog extends React.Component {
    handleClose = () => {
        this.props.onClose(this.props.selectedValue);
    };

    handleListItemClick = value => {
        this.props.onClose(value);
    };

    render() {
        const {data, onClose, selectedValue, ...other} = this.props;
        return (
            <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" {...other}>
                <List>
                    {data.map(str => (
                        <ListItem button onClick={() => this.handleListItemClick(str)} key={str}>
                            <ListItemText primary={str}/>
                        </ListItem>
                    ))}
                </List>
            </Dialog>
        );
    }
}

SimpleDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
    selectedValue: PropTypes.string,
};

const SimpleDialogWrapped = withStyles(styles)(SimpleDialog);

class SimpleDialogSelect extends React.Component {
    state = {
        open: false,
        selectedValue: null,
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    };

    handleClose = (value, reason) => {
        this.setState({selectedValue: value, open: false});
        this.props.onClose(value);
    };

    render() {
        return (
            <div>
                <div onClick={this.handleClickOpen}>
                    {this.props.children}
                </div>
                <SimpleDialogWrapped
                    selectedValue={this.state.selectedValue}
                    open={this.state.open}
                    onClose={this.handleClose}
                    data={this.props.data}
                />
            </div>
        );
    }
}

SimpleDialogSelect.propTypes = {
    data: PropTypes.arrayOf(PropTypes.string)
};

export default SimpleDialogSelect;
